import http from '../http'
/* -------------日志处理接口------------------- */
/**
 * 获取登录日志列表
 * @param {object} search 查询参数, 如: { keyword: '',device:'', stime: '开始时间', etime: '结束时间',, size: 30, page: 1 }
 */
export const getLogs = search => {
    return http.get('/api/loginlog', { params: search })
}
/**
 * 批量删除登录日志
 * @param {array} ids 日志id集合, 例: [1,2,3,4]
 */
export const deleteLogs = ids => {
    return http.delete('/api/loginlog', { data: ids })
}

/**
 * 添加登录日志
 * @param {object} ins 日志参数, 如: { account: '', device: ''}
 */
export const addLog = ins => {
    return http.post('/api/loginlog', ins)
}


// WEBPACK FOOTER //
// ./src/api/gm/api-loginlog.js